import {
  REPEAT_OPTIONS_ID,
  byweekdayOption,
  optionDailySelected,
  optionEndsSelected,
  optionMonthlySelected,
  optionYearlySelected,
} from "./constants";
import { IScheduleScan } from "@/interfaces/scanning/scanInterfaces";
import { RRule, rrulestr } from "rrule";
import { getComponentUiText } from "./utilities";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { convertUTCTimeToLocalTime } from "./dateTimeUtils";
dayjs.extend(utc);

export const getOptionOder = () => {
  return [
    {
      id: 1,
      name: getComponentUiText("app-scanning-schedule-modal-option-first-1"),
    },
    {
      id: 2,
      name: getComponentUiText("app-scanning-schedule-modal-option-second-1"),
    },
    {
      id: 3,
      name: getComponentUiText("app-scanning-schedule-modal-option-third-1"),
    },
    {
      id: 4,
      name: getComponentUiText("app-scanning-schedule-modal-option-fourth-1"),
    },
    {
      id: -1,
      name: getComponentUiText("app-scanning-schedule-modal-option-last-1"),
    },
  ];
};

export const getOptionOfWeek = () => {
  return [
    {
      id: 1,
      name: getComponentUiText("app-scanning-schedule-modal-filed-day-1"),
    },
    {
      id: 2,
      name: getComponentUiText("app-scanning-schedule-modal-option-weekday-1"),
    },
    {
      id: 3,
      name: getComponentUiText(
        "app-scanning-schedule-modal-option-weekend-day-1",
      ),
    },
    {
      id: 4,
      name: getComponentUiText("app-scanning-schedule-modal-option-monday-1"),
    },
    {
      id: 5,
      name: getComponentUiText("app-scanning-schedule-modal-option-tuesday-1"),
    },
    {
      id: 6,
      name: getComponentUiText(
        "app-scanning-schedule-modal-option-wednesday-1",
      ),
    },
    {
      id: 7,
      name: getComponentUiText("app-scanning-schedule-modal-option-thursday-1"),
    },
    {
      id: 8,
      name: getComponentUiText("app-scanning-schedule-modal-option-friday-1"),
    },
    {
      id: 9,
      name: getComponentUiText("app-scanning-schedule-modal-option-saturday-1"),
    },
    {
      id: 10,
      name: getComponentUiText("app-scanning-schedule-modal-option-sunday-1"),
    },
  ];
};

export const getOptionMonth = () => {
  return [
    {
      id: 1,
      name: getComponentUiText("app-scanning-schedule-modal-option-january-1"),
    },
    {
      id: 2,
      name: getComponentUiText("app-scanning-schedule-modal-option-february-1"),
    },
    {
      id: 3,
      name: getComponentUiText("app-scanning-schedule-modal-option-march-1"),
    },
    {
      id: 4,
      name: getComponentUiText("app-scanning-schedule-modal-option-april-1"),
    },
    {
      id: 5,
      name: getComponentUiText("app-scanning-schedule-modal-option-may-1"),
    },
    {
      id: 6,
      name: getComponentUiText("app-scanning-schedule-modal-option-june-1"),
    },
    {
      id: 7,
      name: getComponentUiText("app-scanning-schedule-modal-option-july-1"),
    },
    {
      id: 8,
      name: getComponentUiText("app-scanning-schedule-modal-option-august-1"),
    },
    {
      id: 9,
      name: getComponentUiText(
        "app-scanning-schedule-modal-option-september-1",
      ),
    },
    {
      id: 10,
      name: getComponentUiText("app-scanning-schedule-modal-option-october-1"),
    },
    {
      id: 11,
      name: getComponentUiText("app-scanning-schedule-modal-option-november-1"),
    },
    {
      id: 12,
      name: getComponentUiText("app-scanning-schedule-modal-option-december-1"),
    },
  ];
};

export const getOptionByRepeat = (schedule: IScheduleScan | any) => {
  let rruleOptionsByRepeat;

  const getDateOfMonthly = (id: number) => {
    switch (id) {
      case -1:
        return null;
      case 1:
        return byweekdayOption;
      case 2:
        return [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR];
      case 3:
        return [RRule.SA, RRule.SU];
      default:
        return [byweekdayOption[id - 4]];
    }
  };

  switch (schedule.repeat) {
    case REPEAT_OPTIONS_ID.daily:
      if (schedule.dataByRepeat.daily.value === optionDailySelected.everyWeek) {
        rruleOptionsByRepeat = {
          freq: RRule.DAILY,
          interval: 1,
          byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR],
        };
        break;
      }

      rruleOptionsByRepeat = {
        freq: RRule.DAILY,
        interval: schedule.dataByRepeat.daily.interval,
      };
      break;
    case REPEAT_OPTIONS_ID.weekly:
      rruleOptionsByRepeat = {
        freq: RRule.WEEKLY,
        interval: schedule.dataByRepeat.weekly.interval,
        byweekday: schedule.dataByRepeat.weekly.value.map(
          (item: number) => byweekdayOption[item],
        ),
      };
      break;
    case REPEAT_OPTIONS_ID.monthly:
      if (schedule.dataByRepeat.monthly.value === optionMonthlySelected.day) {
        rruleOptionsByRepeat = {
          freq: RRule.MONTHLY,
          interval: schedule.dataByRepeat.monthly.interval,
          bymonthday: schedule.dataByRepeat.monthly.day,
        };
        break;
      }

      rruleOptionsByRepeat = {
        freq: RRule.MONTHLY,
        interval: schedule.dataByRepeat.monthly.interval,
        bysetpos: schedule.dataByRepeat.monthly.order,
        byweekday: getDateOfMonthly(schedule.dataByRepeat.monthly?.date ?? -1),
      };
      break;
    case REPEAT_OPTIONS_ID.yearly:
      if (schedule.dataByRepeat.yearly.value === optionYearlySelected.onThe) {
        rruleOptionsByRepeat = {
          freq: RRule.YEARLY,
          interval: schedule.dataByRepeat.yearly.interval,
          bymonth: schedule.dataByRepeat.yearly.month,
          bysetpos: schedule.dataByRepeat.yearly.order,
          byweekday: getDateOfMonthly(schedule.dataByRepeat.yearly?.date ?? -1),
        };
        break;
      }

      rruleOptionsByRepeat = {
        freq: RRule.YEARLY,
        interval: schedule.dataByRepeat.yearly.interval,
        bymonth: schedule.dataByRepeat.yearly.month,
        bymonthday: schedule.dataByRepeat.yearly.day,
      };
      break;
  }

  return rruleOptionsByRepeat;
};

export const getDataByRRuleOption = (rrule) => {
  const dataByRepeat = {
    daily: {},
    weekly: {},
    monthly: {},
    yearly: {},
  };

  const getMonthlyOfDate = (byweekday: number[]) => {
    switch (byweekday.length) {
      case 7:
        return 1;
      case 5:
        return 2;
      case 2:
        return 3;
      default:
        return byweekday[0] + 4;
    }
  };

  switch (rrule.options.freq) {
    case 3:
      dataByRepeat.daily = {
        interval: rrule.options.byweekday ? "" : rrule.options.interval,
        value: rrule.options.byweekday
          ? optionDailySelected.everyWeek
          : optionDailySelected.every,
      };
      break;
    case 2:
      dataByRepeat.weekly = {
        interval: rrule.options.interval,
        value: rrule.options.byweekday,
      };
      break;
    case 1:
      dataByRepeat.monthly = {
        interval: rrule.options.interval,
        ...(rrule.options.bysetpos?.length
          ? {
              interval1: rrule.options.interval,
            }
          : {
              interval0: rrule.options.interval,
            }),
        value: rrule.options.bysetpos?.length
          ? optionMonthlySelected.the
          : optionMonthlySelected.day,
        order: rrule.options.bysetpos ? rrule.options.bysetpos[0] : null,
        day: rrule.options.bymonthday ? rrule.options.bymonthday[0] : null,
        date: rrule.options.byweekday
          ? getMonthlyOfDate(rrule.options.byweekday)
          : null,
      };
      break;
    case 0:
      dataByRepeat.yearly = {
        interval: rrule.options.interval,
        value: rrule.options.bysetpos?.length
          ? optionYearlySelected.onThe
          : optionYearlySelected.on,
        order: rrule.options.bysetpos ? rrule.options.bysetpos[0] : null,
        day: rrule.options.bymonthday ? rrule.options.bymonthday[0] : null,
        date: rrule.options.byweekday
          ? getMonthlyOfDate(rrule.options.byweekday)
          : null,
        month: rrule.options.bymonth ? rrule.options.bymonth[0] : null,
        ...(rrule.options.bysetpos?.length
          ? { month1: rrule.options.bymonth ? rrule.options.bymonth[0] : null }
          : {
              month0: rrule.options.bymonth ? rrule.options.bymonth[0] : null,
            }),
      };
      break;
  }

  return dataByRepeat;
};

export const getDtstart = (schedule: IScheduleScan | any) => {
  const isPM = schedule.at.includes("pm");
  let hour = schedule.at.split(":")[0];
  let minute = schedule.at.split(":")[1].replace(" ", "");

  if (isPM) {
    hour = hour === "12" ? hour : (parseInt(hour) + 12).toString();
    minute = minute.replace("pm", "");
  }
  if (!isPM) {
    hour = hour === "12" ? "00" : hour;
    minute = minute.replace("am", "");
  }

  return new Date(
    `${dayjs(schedule.starts).format("YYYY-MM-DD")}T${hour}:${minute}:00Z`,
  );
};

export const convertScheduleToRRuleString = (schedule: IScheduleScan | any) => {
  const rruleOptionsByRepeat = getOptionByRepeat(schedule);

  const renderEnds = (value) => {
    if (value === optionEndsSelected.never) {
      return {};
    }
    if (value === optionEndsSelected.after) {
      return { count: schedule.ends.count };
    }
    if (value === optionEndsSelected.on) {
      return {
        until: new Date(
          `${dayjs(schedule.ends.until).format("YYYY-MM-DD")}T00:00:00Z`,
        ),
      };
    }
  };

  const rruleOptions = {
    ...rruleOptionsByRepeat,
    ...renderEnds(schedule.ends.value),
    dtstart: getDtstart(schedule),
  };
  const rule = new RRule(rruleOptions);

  return rule.toString();
};

export const convertRRuleStringToSchedule = (rule: string) => {
  const rrule = rrulestr(rule);
  const dataByRepeat = getDataByRRuleOption(rrule);

  const convertTimeTo12Hour = () => {
    // const [hours, minutes] = time.split(":");
    const hours = rule.slice(17, 19);
    const minutes = rule.slice(19, 21);
    const hour = hours.padStart(2, "0");
    const min = minutes.padStart(2, "0");
    const ampm = +hour >= 12 ? "pm" : "am";
    const hour12 = +hour % 12 || 12;
    const hour12Str = hour12.toString().padStart(2, "0");
    return `${hour12Str}:${min} ${ampm}`;
  };

  const renderEndsValue = () => {
    const endObjValue: any = {
      value: optionEndsSelected.never,
      until: null,
      count: null,
    };

    if (rrule.options.count) {
      endObjValue.value = optionEndsSelected.after;
      endObjValue.count = rrule.options.count;
    }
    if (rrule.options.until) {
      endObjValue.value = optionEndsSelected.on;
      const until = rrule.options.until;

      endObjValue.until = dayjs(until).utc().format("MM-DD-YYYY");
    }

    return endObjValue;
  };

  const getStarts = () => {
    const dtstart = rrule.options.dtstart;
    return dayjs(dtstart).utc().format("MM-DD-YYYY");
  };

  const schedule = {
    repeat: Object.keys(REPEAT_OPTIONS_ID)[rrule.options.freq],
    dataByRepeat,
    starts: getStarts(),
    at: convertTimeTo12Hour(),
    ends: renderEndsValue(),
  };

  return schedule;
};

export const getTextFromRRule = (rule: string) => {
  const schedule: IScheduleScan | any = convertRRuleStringToSchedule(rule);
  const optionRepeat = getOptionByRepeat(schedule);
  const rrule = new RRule(optionRepeat);
  const OPTION_ORDER = getOptionOder();
  const OPTION_OF_WEEK = getOptionOfWeek();
  const OPTION_MONTH = getOptionMonth();
  let text = rrule.toText();

  if (
    schedule.repeat === "monthly" &&
    schedule.dataByRepeat.monthly?.value === optionMonthlySelected.the
  ) {
    const isOne = schedule.dataByRepeat.monthly.interval === 1;
    const monthString = isOne ? "month" : "months";
    text =
      `every ${isOne ? "" : `${schedule.dataByRepeat.monthly.interval} `}` +
      monthString +
      ` on the ${
        OPTION_ORDER[
          schedule.dataByRepeat.monthly?.order === -1
            ? 4
            : schedule.dataByRepeat.monthly?.order - 1
        ].name
      } ${OPTION_OF_WEEK[schedule.dataByRepeat.monthly?.date - 1].name}`;
  }

  if (
    schedule.repeat === "yearly" &&
    schedule.dataByRepeat.yearly?.value === optionYearlySelected.onThe
  ) {
    const isOne = schedule.dataByRepeat.yearly.interval === 1;
    const yearString = isOne ? "year" : "years";
    text =
      `every ${isOne ? "" : `${schedule.dataByRepeat.yearly.interval} `}` +
      yearString +
      ` on the ${
        OPTION_ORDER[
          schedule.dataByRepeat.yearly?.order === -1
            ? 4
            : schedule.dataByRepeat.yearly?.order - 1
        ].name
      } ${OPTION_OF_WEEK[schedule.dataByRepeat.yearly?.date - 1].name} of ${
        OPTION_MONTH[schedule.dataByRepeat.yearly?.month - 1].name
      }`;
  }

  return text;
};

export const getNextScanFromRRule = (rule: string) => {
  const now = new Date();
  const rrule = rrulestr(rule);
  const timeZoneOffset = now.getTimezoneOffset() / 60;
  now.setHours(now.getHours() - timeZoneOffset);
  const after = rrule.after(now, true);

  if (after) {
    const differenceInMilliseconds = after.getTime() - now.getTime();
    const differenceInMinutes = Math.ceil(
      differenceInMilliseconds / (60 * 1000),
    );
    const differenceInHours = Math.ceil(differenceInMinutes / 60);
    const differenceInDays = Math.ceil(differenceInHours / 24);

    if (differenceInMinutes > 0 && differenceInMinutes < 60) {
      return `in ${differenceInMinutes} minute${
        differenceInMinutes > 1 ? "s" : ""
      }`;
    }

    if (differenceInHours > 0 && differenceInHours < 24) {
      return `in ${differenceInHours} hour${differenceInHours > 1 ? "s" : ""}`;
    }

    if (differenceInDays > 0 && differenceInDays < 31) {
      return `in ${differenceInDays} day${differenceInDays > 1 ? "s" : ""}`;
    }

    if (differenceInDays >= 31) {
      return convertUTCTimeToLocalTime(after.toISOString());
    }
  } else {
    return "";
  }
};

export default {
  convertScheduleToRRuleString,
  convertRRuleStringToSchedule,
  getTextFromRRule,
  getNextScanFromRRule,
  getOptionByRepeat,
  getDataByRRuleOption,
  getOptionOder,
  getOptionOfWeek,
  getOptionMonth,
};
